import CallMadeIcon from '@mui/icons-material/CallMade';

export default function LinkComponent( { icon, description, link, domain, color = "var(--black4)" } ){
    return(
        <a href = { link } target = "_blank">
            <div className = "linkComponent" style = { { background : "white", display : "flex", flexDirection : "row", gap : "4px", alignItems : "center", justifyContent : "flex-start", padding : "12px 6px", marginBottom : "8px", border : `1px solid var(--black4)`, borderRadius : "8px" }}>
                {/* <div style = { { display : "flex", alignSelf: "stretch" } }>
                    <img style = { { width : "16px", height: "16px" } } src = { icon }/>
                </div> */}

                <div className = "iconWrapper">
                    <CallMadeIcon className = "animationLinkIcon" style = { { fill : color, fontSize: "var(--font-size-small)" } } />
                </div>

                <div style = { { display : "flex", flexDirection : "column", alignItems : "flex-start" } }>
                    <p>{ description }</p>
                    <p style = { { color : "var(--black56)", fontSize : "var(--font-size-tiny)", lineHeight : "140%" } }>{ domain }</p>
                    <p className = "meta2" style = { { color : "var(--black32)", paddingTop : "6px" } }>{ link }</p>
                </div>
            </div>
        </a>
    )
}